import React from 'react';
import styles from './Tabs.module.scss';

import { useAssetsDashboardsActions, useAssetsDashboardsSelector } from 'hooks/AssetsDashboards';

import ToggleBar from 'components/ToggleBars/ToggleBar';

import { TOGGLE_BUTTONS } from '../../helpers';

export default function DashboardTabs() {
  const { setTabAction } = useAssetsDashboardsActions();
  const { tab } = useAssetsDashboardsSelector();

  const clickTab = (tab) => setTabAction(tab);

  return (
    <ToggleBar
      buttons={TOGGLE_BUTTONS}
      onChange={clickTab}
      selectedTab={tab}
      classes={styles.bar}
    />
  );
}
